<!--Desktop Banner-->
@if (isAllStarKid) {
<div
  class="banner d-none d-lg-flex align-items-center justify-content-center"
  role="banner"
  [style.backgroundImage]="'url(' + ('kids/banners/allstars/banner.png' | contentAssetImage) + ')'"
>
  <h5 class="text-black fw-bold text-uppercase mb-0">{{ 'trainingzone.page.title' | translate }}</h5>
</div>
} @else {
<fgb-desktop-nav-banner [pageName]="'trainingzone.page.title' | translate" [forceDefaultBanner]="true"></fgb-desktop-nav-banner>
}

<!--Mobile Navigation-->
<fgb-mobile-nav-menu
  [pageName]="'trainingzone.page.title' | translate"
  [showHamburger]="false"
  [showWalletButton]="false"
></fgb-mobile-nav-menu>

<fgb-worksheet-list></fgb-worksheet-list>
